import { createContext } from 'react';

const FileDragContext = createContext({
  isFileDraggedOnPage: false,
  setIsFileDraggedOnPage(value:boolean):void { /* */ },
});

export default FileDragContext;
